/**
 * Defines the behavior of a funnel series
 */
import { appendChildElement, removeElement } from '../../common/utils/helper';
import { TriangularBase } from './triangular-base';
/**
 * FunnelSeries module used to render `Funnel` Series.
 */
export class FunnelSeries extends TriangularBase {
    /**
     * Defines the path of a funnel segment
     */
    getSegmentData(point, series, chart) {
        let lineWidth;
        let topRadius;
        let bottomRadius;
        let endTop;
        let endBottom;
        let minRadius;
        let endMin;
        let bottomY;
        let area = series.triangleSize;
        let offset = 0;
        let extraSpace = (chart.initialClipRect.width - series.triangleSize.width) / 2;
        let emptySpaceAtLeft = extraSpace + chart.initialClipRect.x;
        let seriesTop = chart.initialClipRect.y + (chart.initialClipRect.height - area.height) / 2;
        //defines the top and bottom of a segment
        let top = point.yRatio * area.height;
        let bottom = top + point.heightRatio * area.height;
        let neckSize = series.neckSize;
        lineWidth = neckSize.width + (area.width - neckSize.width) * ((area.height - neckSize.height - top) /
            (area.height - neckSize.height));
        topRadius = (area.width / 2) - lineWidth / 2;
        //Calculating the middle slope change and bottom
        endTop = topRadius + lineWidth;
        if (bottom > area.height - neckSize.height || area.height === neckSize.height) {
            lineWidth = neckSize.width;
        }
        else {
            lineWidth = neckSize.width + (area.width - neckSize.width) *
                ((area.height - neckSize.height - bottom) / (area.height - neckSize.height));
        }
        bottomRadius = (area.width / 2) - (lineWidth / 2);
        endBottom = bottomRadius + lineWidth;
        if (top >= area.height - neckSize.height) {
            topRadius = bottomRadius = minRadius = (area.width / 2) - neckSize.width / 2;
            endTop = endBottom = endMin = (area.width / 2) + neckSize.width / 2;
        }
        else if (bottom > (area.height - neckSize.height)) {
            minRadius = bottomRadius = (area.width / 2) - lineWidth / 2;
            endMin = endBottom = minRadius + lineWidth;
            bottomY = area.height - neckSize.height;
        }
        top += seriesTop;
        bottom += seriesTop;
        bottomY += seriesTop;
        let line1 = { x: emptySpaceAtLeft + offset + topRadius, y: top };
        let line2 = { x: emptySpaceAtLeft + offset + endTop, y: top };
        let line4 = { x: emptySpaceAtLeft + offset + endBottom, y: bottom };
        let line5 = { x: emptySpaceAtLeft + offset + bottomRadius, y: bottom };
        let line3 = { x: emptySpaceAtLeft + offset + endBottom, y: bottom };
        let line6 = { x: emptySpaceAtLeft + offset + bottomRadius, y: bottom };
        if (bottomY) {
            line3 = { x: emptySpaceAtLeft + offset + endMin, y: bottomY };
            line6 = { x: emptySpaceAtLeft + offset + minRadius, y: bottomY };
        }
        let polygon = [line1, line2, line3, line4, line5, line6];
        this.setLabelLocation(series, point, polygon);
        let direction = this.findPath(polygon);
        return direction;
    }
    /**
     * Renders a funnel segment
     * @private
     */
    renderPoint(point, series, chart, options, seriesGroup, redraw) {
        if (!point.visible) {
            removeElement(options.id);
            return null;
        }
        let direction = this.getSegmentData(point, series, chart);
        point.midAngle = 0;
        options.d = direction;
        appendChildElement(false, seriesGroup, chart.renderer.drawPath(options), redraw);
        if (point.isExplode) {
            chart.accBaseModule.explodePoints(point.index, chart, true);
        }
    }
    /**
     * To get the module name of the funnel series.
     */
    getModuleName() {
        return 'FunnelSeries';
    }
    /**
     * To destroy the funnel series.
     * @return {void}
     * @private
     */
    destroy(accumulation) {
        /**
         * Destroys the funnel series
         */
    }
}
